import { render, staticRenderFns } from "./ThumbnailPhotoSelector.vue?vue&type=template&id=fb03135a&scoped=true"
import script from "./ThumbnailPhotoSelector.vue?vue&type=script&lang=js"
export * from "./ThumbnailPhotoSelector.vue?vue&type=script&lang=js"
import style0 from "./ThumbnailPhotoSelector.vue?vue&type=style&index=0&id=fb03135a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb03135a",
  null
  
)

export default component.exports